import React from 'react';
import { RadioButtonGroup } from '@framework-controls/core';
// import SVPButton from 'src/components/SVPButtons/SVPButton';
// import classNames from 'classnames';
import { strings } from 'src/localization/index';
import css from './DesktopDiagnoseModal.module.scss';
// import { diagnoseResponses } from '../../DiagnoseTree/DiagnoseTree';

interface IProps {
    title: string
    selectedButton: string;
    diagnoseTree?: JSX.Element[];
    selectButtonHandler: (value: string) => void;
}

const DiagnoseTree = (props: IProps) => (
    <div>
        <h4 id='h4LightBox' className={css.dialogTitle}>{strings.WalkThroughDiagnose}</h4>
        <h5 id='title'>{props.title}</h5>
        <RadioButtonGroup
            value={props.selectedButton}
            id='currentResponses'
            onChange={(_, value) => props.selectButtonHandler(value)}>
            {props.diagnoseTree}
        </RadioButtonGroup>
    </div>
);

export default DiagnoseTree;